export default __webpack_public_path__ + "static/media/track.48172c1f.png";